import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { deleteLeaveTypeURL } from "../../../../Library/URLs";
// import { CircularProgress } from "@mui/material";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "552px",
    fontFamily: "Quicksand",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
    fontFamily: "Quicksand",
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2,fontFamily:'Quicksand, sans-serif' }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const DeleteLeaveType = ({ open, handleClose, updateLeaveTypes, leaveType }) => {
  const unique_id = uuid();
  const { companyid } = useParams();
  const { User } = useSelector((state) => state.payroll);
  const proxyEmployee = useSelector((state) => state.payroll.Proxy);

  const [isLoading, setIsLoading] = useState(false);

  const deleteLeaveType = async () => {
    // console.log('all employee API is call')
    setIsLoading(true);
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      leave_type_id: leaveType,
      proxy_id: proxyEmployee?.success?proxyEmployee?.id:null,
    };
    await axios
      .post(deleteLeaveTypeURL, raw)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          handleClose();
          updateLeaveTypes();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log("error" + err.message);
        toast.error("Request Failed");
        setIsLoading(false);
      });
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      // maxWidth={'sm'}
      // fullWidth={true}
      className="Dialog_Wrap"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        <div className="Name">Delete Absence Type</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div>
          <div className="Confirmation" >
            Are you sure?
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Pay_Item_Btn_Action_Wrapper">
          <div className="Btn" onClick={handleClose}>
            Cancel
          </div>

          <div className="Btn Delete_Btn" onClick={deleteLeaveType}>
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "Delete"
            )}
          </div>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default DeleteLeaveType;
